import { render, staticRenderFns } from "./Service.vue?vue&type=template&id=95e39870&scoped=true&"
import script from "./Service.vue?vue&type=script&lang=js&"
export * from "./Service.vue?vue&type=script&lang=js&"
import style0 from "./Service.vue?vue&type=style&index=0&id=95e39870&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95e39870",
  null
  
)

export default component.exports